if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
        autoplay:false,
        autoplaySpeed:4000,
        speed:1000
    });

    $('.reviews__information').slick({
        accessibility: false,
        fade:true,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1000,
         responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: true,
               }
            }
        ]
    });

     $('.single-slider-carousel').slick({
         dots: false,
         arrows: false,
         fade:true,
         autoplay:true,
         autoplaySpeed:4000,
         speed:1000,
          accessibility: false
    }); 



    $('.sym-slider-amenities').slick({
        dots: true,
        arrows: false,
        fade:true,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1000,
        accessibility: false,
          responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: true,
               }
            }
        ]
   }); 


    //dots funcionality for single-slider
    $('.js-slick-dots').each((i, dots) => {
        $('button', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $(dots).closest('.slick-slider').slick('slickGoTo', slideTo);
        });
    });


    $('.sym-gallery').slick({
        accessibility: false,
        centerMode: false,
        variableWidth: true,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1000,
        centerPadding: '20px',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false,
                }
            }
        ]
    });

    $('.sym-two-cards').slick({
        accessibility: false,
        autoplay:false,
        autoplaySpeed:4000,
        speed:1000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false,
               }
            }
        ]
    });

    $('.sym-amenities-golf').slick({
        accessibility: false,
        autoplay:false,
        autoplaySpeed:4000,
        speed:1000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false,
               }
            }
        ]
    });

     $('.sym-slider-quad').slick({
        accessibility: true,
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1000,
        focusOnSelect: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  adaptiveHeight: true
               }
            }
        ]
    });

    

    $('.sym-slides-accommodations').slick({
        accessibility: false
    })


    // Quad filter-info 
    $('.filter-info-text').slick({
        accessibility: false,
        slidesToShow: 9,
        slidesToScroll: 1,
        asNavFor: '.filter-info-content',
        focusOnSelect: true,
        infinite: false,
        responsive: [
            {
            breakpoint: 600,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    })
    $('.filter-info-content').slick({
        accessibility: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite:false,
        asNavFor: '.filter-info-text'
    })
    // Close Quad filter-info




    // ------ Script Quad Accordion --------
    var accordionItems = document.querySelectorAll('.accordion__item');
    var i;
    for (i = 0; i < accordionItems.length; i++) {
        let disItem = accordionItems[i];
        let disBtn = disItem.querySelector('.accordion__btn');
        disBtn.addEventListener('click', function () {
            disItem.classList.toggle('open');
        });
	}
	//-------End Script Accordeon ---------

    //menus
       document.querySelectorAll('.js-menu-tab').forEach((btn) => {
        btn.addEventListener('click', _ => {
            $('.js-menu-tab.active').removeClass('active');
            $(btn).addClass('active');
            $('.quad-menus__menu-content.active').removeClass('active');
            var tabNumber = $(btn).attr('data-menuid');
            var tabToOpen = ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass('active');
            $('.quad-menus__tabs-image.active').removeClass('active');
            var imgToOpen = ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass('active');
            $('.name-bg.active').removeClass('active');
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass('active');
        });
    });
	//-------End Menu Accordeon ---------

       //email signup animation 
    if(document.getElementById('email-signup')){
        document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
            this.parentElement.classList.add('moved');
        })
        document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
            this.parentElement.classList.add('moved');
        }) 
        document.getElementById('email-signup_email_address').addEventListener('focus', function(){
        this.parentElement.classList.add('moved');
        })

	}
    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    //Validation footer for padding top if it has slider inmersive quad
    let footer = document.querySelector('#footer_main');
    // find all section and verify if the last item has slider
    let main = document.querySelectorAll('#content section');
    let mainLenght = main.length-1;

    main.forEach((section,position) => {
        //verify the last quad if it has slider
        if(position == mainLenght){
            if (section.classList.contains('js-slider-inmersive')){
                if(footer!= undefined || footer!=null){
                    footer.classList.add('js-footer-hight-slider');
                }
                section.classList.add('js-slider-inside-footer');
            }
        }
    })



       //mobile burger menu
       document.getElementById('burgerMenu').addEventListener('click', function () {
        if (!this.classList.contains('open')) {
            this.parentElement.classList.add('open');
            this.classList.add('open');
            document.querySelector(".overlay").classList.add("open");
            document.getElementById("logo-sm").classList.remove("hidden");
            let button = document.getElementById("Close").parentElement.parentElement;
            if (button.childNodes.length == 2) {
                let newText = document.createElement("div");
                newText.textContent = "CLOSE";
                newText.classList.add("jsCloseBtn")
                button.appendChild(newText);
            }
        }
        else {
            this.classList.remove('open');
            document.getElementById("logo-sm").classList.add("hidden");
            let button = document.getElementById("Close").parentElement.parentElement;
            button.removeChild();
            this.parentElement.classList.remove('open');
            document.querySelector(".overlay").classList.remove("open");
        }
    });

    //close btn mobile
    let closeBtn = document.querySelectorAll(".nav-container")[0];
    let newButton = closeBtn.childNodes[1];
    console.log(newButton)
    if (newButton != undefined) {
        if (closeBtn.childNodes[1].classList.contains("mobile")) {
            let generalbutton = closeBtn.childNodes[1].children[1].children[0];
            generalbutton.addEventListener('click', function () {
                document.getElementById("logo-sm").classList.add("hidden");
                document.querySelectorAll('.overlay')[0].classList.remove('open');
                document.getElementById('burgerMenu').classList.remove('open');
            })
        }
	}

    
    //dropdown for mobile
	document.querySelectorAll('.inner > ul > li > a').forEach(link => {
		link.addEventListener('click', e => {
			if (link.nextSibling.nextSibling != null) {
				document.querySelectorAll('.inner > ul > li').forEach(item => {
					if (link.parentNode !== item) item.classList.remove('js-submenu-show');
				});
				//remove this comment if you want show subnav for mobile
				e.preventDefault();
				link.parentNode.classList.toggle('js-submenu-show');
			}
		});
	});
	//add class for icon dropdown 
	document.querySelectorAll('.inner > ul > li > .sub-sub-menu').forEach(link => {
		let menu = link.parentNode.firstElementChild;
		menu.classList.add('ico-dropdown');
	})
	//--------------------


    //Seccion gallery and template
    
    const customLightboxFooter = new LBX(".js-my-lightbox", {
        fullScreen:true,
    });
   if( customLightboxFooter != null){
        customLightboxFooter.fullScreen =true
   }
   //--------------------

})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#navigationBox');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a, .social-media a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#navigationBox');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});

/** ADA included in an ARIA landmark **/
document.addEventListener("DOMContentLoaded", () => {
    const navigationRight = document.querySelector(".navigation-info__right");
    
    if (navigationRight) {
        navigationRight.setAttribute("role", "region");
        navigationRight.setAttribute("aria-label", "Footer Navigation and Social Media");
    }
});